module.exports = __webpack_public_path__ + "img/keyan.d42b7849.jpg";